import { Component, Input, inject, signal, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicComponentLoaderDirective } from '../../directives/dynamic-component-loader.directive';
import { BUTTON_TYPE, ICON, UiSharedLibraryModule } from '@i-wyze/ui-shared-library';
import { EventService } from '../../services/event.service';

@Component({
	selector: 'wyzeweb-section',
	standalone: true,
	imports: [CommonModule, UiSharedLibraryModule, DynamicComponentLoaderDirective],
	templateUrl: './section.component.html',
	styleUrl: './section.component.scss'
})
export class SectionComponent implements AfterViewInit {
	public readonly BUTTON_TYPE = BUTTON_TYPE;
	public readonly ICON = ICON;
	@Input() data: any;
	@Input() index!: number;
	@Input() modifiedDate = '';
	@Input() pageUrl = '';
	isOpen = signal<boolean>(true);

	constructor(private elementRef: ElementRef) {}

	ngAfterViewInit(): void {
		if (this.pageUrl?.startsWith('blog/') && this.pageUrl !== 'blog' && this.modifiedDate) {
			const root = this.elementRef.nativeElement;

			const publishDiv = root.querySelector('.publish-date');
			if (publishDiv && !publishDiv.classList.contains('updated-appended')) {
				publishDiv.textContent += this.getUpdateText();
				publishDiv.classList.add('updated-appended');
				return;
			}

			const paragraphs = root.querySelectorAll('.loose-text p');
			for (const p of paragraphs) {
				if (
					p.textContent?.trim().startsWith('This post was published on') &&
					!p.classList.contains('updated-appended')
				) {
					p.textContent += this.getUpdateText();
					p.classList.add('updated-appended');
					break;
				}
			}
		}
	}

	eventService = inject(EventService);

	public get sectionTitleClass(): string {
		return this.data?.variant
			? `page-section__title page-section__title--${this.data.variant}`
			: 'page-section__title';
	}

	public getIconPath(name: string): string {
		return ICON[name as keyof typeof ICON];
	}

	handleButtonClick(event: string): void {
		this.eventService.handleEvent({ event, redirectUrl: this.data.learn_more_url });
	}

	get sectionClosedContentClass(): string {
		return `section-closed__content section-closed__content--${this.data?.variant}`;
	}

	private getUpdateText(): string {
		const date = new Date(this.modifiedDate);
		const formatted = date.toLocaleDateString('en-GB', {
			day: '2-digit',
			month: 'long'
		});
		const year = date.getFullYear();
		return ` | Updated on ${formatted}, ${year}`;
	}
}
